/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
export const dimensions = {
  header: {
    height: {
      desktop: 70,
      mobile: 62,
    },
  },
  menu: {
    height: {
      desktop: 40,
    },
  },
  searchBar: {
    width: 340,
    height: 40,
  },
  productCard: {
    swatch: 20,
    thumbnail: 140,
  },
  pagination: {
    button: 40,
  },
  inputFields: {
    height: 45,
  },
};
